import classNames from 'classnames'
import Image from 'next/image'
import React from 'react'

import { HowToMakeSongChapters } from '../../../../utils/blog-guides/howToMakeSongConstants'
import Container from '../../../common/Container/container'
import Link from '../../../common/Link/Link'
import styles from './how-to-make-song-guide.module.scss'

type Props = {
  className?: string
  chaptersIndexes?: number[]
  chapterMode?: boolean
}

const HowToMakeSongGuide: React.FC<Props> = ({ className, chaptersIndexes, chapterMode }) => {
  return (
    <section className={styles.section} data-chapter={chapterMode}>
      <Container className={styles.container}>
        <svg className={styles.bg} viewBox='0 0 682 212' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M28.1893 126.289C20.4941 131.534 19.9708 133.16 22.288 143.525C17.4887 134.242 16.0813 133.556 7.35756 135.833C15.0527 130.588 15.5761 128.962 13.2589 118.598C18.0011 127.851 19.4258 128.585 28.1893 126.289Z'
            fill='url(#paint0_linear_1691_218837)'
          />
          <path
            d='M676.47 93.9332C669.307 92.5401 668.28 93.2039 665.353 100.759C666.229 92.3901 665.619 91.1521 659.06 87.381C666.223 88.7741 667.25 88.1103 670.177 80.5554C669.277 88.8731 669.878 90.1496 676.47 93.9332Z'
            fill='url(#paint1_linear_1691_218837)'
          />
          <path
            d='M481.421 59.5541C479.36 58.239 477.447 57.0013 475.515 55.7965C475.366 55.7191 475.144 55.8283 474.682 55.8817C475.428 56.7197 475.974 57.4361 476.6 58.0209C478.263 59.5435 479.94 60.9783 481.642 62.4351C481.849 62.6117 482.035 62.8212 482.281 62.9319C483.051 63.3413 483.62 62.9804 483.714 61.9143C483.751 61.3978 483.742 60.892 483.688 60.3972C483.484 58.5276 483.234 56.6688 482.984 54.8101C482.948 54.4802 482.775 54.1828 482.604 53.6875C481.543 55.322 482.582 56.9085 482.074 58.4679C481.881 58.2034 481.695 57.9939 481.554 57.7736C476.052 49.3782 468.954 43.7038 460.615 40.158C459.754 39.7703 458.84 39.5364 457.946 39.2696C457.486 39.1251 456.958 39.2223 456.828 39.9584C456.672 40.6725 457.034 40.9815 457.585 41.1043C463.786 42.4223 468.866 46.3199 473.76 50.6567C476.32 52.897 478.631 55.4222 480.678 58.3203C480.928 58.6839 481.159 59.0805 481.421 59.5541Z'
            fill='url(#paint2_linear_1691_218837)'
          />
          <defs>
            <linearGradient
              id='paint0_linear_1691_218837'
              x1='12.5141'
              y1='129.952'
              x2='32.4558'
              y2='132.317'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='#5A7FFF' />
              <stop offset='1' stopColor='#7BB8FF' />
            </linearGradient>
            <linearGradient
              id='paint1_linear_1691_218837'
              x1='664.867'
              y1='86.901'
              x2='677.614'
              y2='99.0185'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='#5A7FFF' />
              <stop offset='1' stopColor='#7BB8FF' />
            </linearGradient>
            <linearGradient
              id='paint2_linear_1691_218837'
              x1='477.319'
              y1='52.7972'
              x2='467.898'
              y2='58.5923'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='#5A7FFF' />
              <stop offset='1' stopColor='#7BB8FF' />
            </linearGradient>
          </defs>
        </svg>

        <h3 className={styles.title} data-chapter={chapterMode}>
          {chapterMode ? 'Related Articles' : 'The Ultimate Guide to Songwriting for Beginners'}
        </h3>
        {!chapterMode && (
          <p className={styles.subtitle}>
            Follow these 7 interactive chapters to gain a robust understanding of fundamental songwriting processes and
            practice along the way.
          </p>
        )}
        <div className={classNames(className, styles.chapters)}>
          {HowToMakeSongChapters.filter((ch, index) => !chaptersIndexes || chaptersIndexes.includes(index)).map(
            (ch) => (
              <Link href={ch.link} key={ch.title} className={styles.chapter}>
                <div className={styles.imgWrapper}>
                  <Image
                    src={`/static/images/landing/how-to-make-song/${ch.img}`}
                    alt=''
                    width={chapterMode ? 130 : 184}
                    height={chapterMode ? 130 : 184}
                  />
                </div>
                <div>
                  <h5>{ch.title}</h5>
                  <p>{ch.description}</p>
                </div>
              </Link>
            ),
          )}
        </div>
      </Container>
    </section>
  )
}

export default HowToMakeSongGuide
